import React, { useMemo, useState } from 'react';
import ChatPage from './ChatPage';
import LoginPage from './LoginPage';
import { clearAuth, getSavedUser, getToken, isTokenExpired } from './auth';

export default function App() {
  const [authVersion, setAuthVersion] = useState(0);
  const authenticated = useMemo(() => {
    const token = getToken();
    return Boolean(token) && !isTokenExpired(token);
  }, [authVersion]);

  const user = getSavedUser();

  const handleLogin = () => setAuthVersion((v) => v + 1);
  const handleLogout = () => {
    clearAuth();
    setAuthVersion((v) => v + 1);
  };

  if (!authenticated) return <LoginPage onLogin={handleLogin} />;

  return <ChatPage user={user} onLogout={handleLogout} />;
}
